import http from "./httpService";
import auth from "./authService";

function supplierStoreUrl(id) {

  if (id) return `/v1/passport-inout/${id}`;
  else return `/v1/passport-inout`;
}

export function getAllEntries(supplierId) {
  return http.get(
    `/v1/passport-inout-get-all/${supplierId}`
  );
}

export function deletePassport(supplierId) {
  return http.delete(supplierStoreUrl(supplierId));
}

export function save(supplier) {
  return http.post(supplierStoreUrl(), supplier);
}

export function update(supplier) {
  return http.put(supplierStoreUrl(supplier.id), supplier);
}

export function updateStatus(supplier) {
  return http.get(
    `/v1/passport-inout/${auth.getCurrentUser().company_id}/${supplier.id}/status`
  );
}